module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "device-list"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody'), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("#IID")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("PS Service Version")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Manufacturer")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Model")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("App Version")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Debug Version")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Facebook")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Messenger")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("App Install Updated")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("App Login Updated")])])])])])])]), _vm._v(" ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("#IID")]), _vm._v(" "), _c('th', [_vm._v("Google Play Services")]), _vm._v(" "), _c('th', [_vm._v("Manufacturer")]), _vm._v(" "), _c('th', [_vm._v("Model")]), _vm._v(" "), _c('th', [_vm._v("App Version")]), _vm._v(" "), _c('th', [_vm._v("Debug Version")]), _vm._v(" "), _c('th', [_vm._v("Facebook")]), _vm._v(" "), _c('th', [_vm._v("Messenger")]), _vm._v(" "), _c('th', [_vm._v("App Install Updated")]), _vm._v(" "), _c('th', [_vm._v("App Login Updated")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e6b0d724!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Device/DeviceList.vue
// module id = 174
// module chunks = 2